// ソファ: 座面・背もたれクッションとアームレスト
import { Box } from '@react-three/drei'

export default function SofaMesh({ width, height, depth, position, color, isSelected }) {
    // 参考画像に基づく比率（全高78cm、座面高39cm = 50%）
    // - 座面フレーム: 50%（下部、座面高さ）
    // - 背もたれクッション: 50%（上部）
    // - アームレスト: 背もたれの半分 = 25%

    const frameHeight = height * 0.50          // 座面フレーム（下半分）
    const backCushionHeight = height * 0.65    // 背もたれクッション（上半分）
    const seatCushionHeight = height * 0.10    // 座面クッションの厚み
    const seatFrameHeight = height * 0.10      // 座面フレームの厚み（クッションと同じ）
    const armWidth = width * 0.05              // アームレスト幅
    const armHeight = height * 0.75            // アームレスト高さ（背もたれ中間まで）

    // Y座標計算
    const seatCushionY = position[1] - height / 2 + frameHeight - seatCushionHeight / 2
    const seatFrameY = seatCushionY - seatCushionHeight / 2 - seatFrameHeight / 2  // クッションの直下
    const seatFrameBottom = seatFrameY - seatFrameHeight / 2  // 座面フレームの下端
    const boundingTop = position[1] + height / 2  // バウンディングボックスの上端
    const actualBackHeight = boundingTop - seatFrameBottom  // 背もたれの実際の高さ
    const backCushionY = seatFrameBottom + actualBackHeight / 2  // 背もたれの下端を座面フレームの下端に揃える
    const armY = position[1] - height / 2 + armHeight / 2  // 下から配置

    // 内側の幅（アームレストを除く）
    const innerWidth = width - armWidth * 2

    return (
        <group>
            {/* 座面フレーム（アームレストの内側に収まる） */}
            <Box args={[innerWidth, seatFrameHeight, depth * 0.90]} position={[0, seatFrameY, depth * 0.05]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.6} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 座面クッション（フレームと同じサイズ） */}
            <Box args={[innerWidth, seatCushionHeight, depth * 0.90]} position={[0, seatCushionY, depth * 0.05]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.5} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 背もたれクッション（座面と同じ幅・フル高さ） */}
            <Box args={[innerWidth, actualBackHeight, depth * 0.12]} position={[0, backCushionY, -depth * 0.44]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.5} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 左アームレスト（全奥行きで前後のワイヤーフレームに接触） */}
            <Box args={[armWidth, armHeight, depth]} position={[-width / 2 + armWidth / 2, armY, 0]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.6} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 右アームレスト（全奥行きで前後のワイヤーフレームに接触） */}
            <Box args={[armWidth, armHeight, depth]} position={[width / 2 - armWidth / 2, armY, 0]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.6} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* ワイヤーフレーム - 座面フレーム */}
            <Box args={[innerWidth, seatFrameHeight, depth * 0.90]} position={[0, seatFrameY, depth * 0.05]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 座面クッション */}
            <Box args={[innerWidth, seatCushionHeight, depth * 0.90]} position={[0, seatCushionY, depth * 0.05]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 背もたれクッション */}
            <Box args={[innerWidth, actualBackHeight, depth * 0.12]} position={[0, backCushionY, -depth * 0.44]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 左アームレスト */}
            <Box args={[armWidth, armHeight, depth]} position={[-width / 2 + armWidth / 2, armY, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 右アームレスト */}
            <Box args={[armWidth, armHeight, depth]} position={[width / 2 - armWidth / 2, armY, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* 選択時のハイライト */}
            {isSelected && (
                <Box args={[width, height, depth]} position={position}>
                    <meshBasicMaterial
                        color="#fbbf24"
                        wireframe
                        opacity={0.8}
                        transparent
                    />
                </Box>
            )}
        </group>
    )
}
